import { render } from "./request-list.vue?vue&type=template&id=236c00d6&scoped=true"
import script from "./request-list.vue?vue&type=script&lang=js"
export * from "./request-list.vue?vue&type=script&lang=js"

import "./request-list.vue?vue&type=style&index=0&id=236c00d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-236c00d6"

export default script